import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
} from "@mui/material";
import { useState } from "react";
import {
  loadObjectFromLocalStorage,
  saveObjectToLocalStorage,
} from "../../save/localSave";

export default function ProducerStrengtheningDialog(props: {
  open: boolean;
  onClose: () => void;
  onReset: () => void;
}) {
  const [hideOnNextReset, setHideOnNextReset] = useState(false);
  const localHide = loadObjectFromLocalStorage(
    "hideProducerStrengtheningDialog"
  );
  return (
    <Dialog open={props.open && !localHide} onClose={props.onClose}>
      <DialogTitle style={{ color: "#2196f3" }}>
        Producer Strengthening
      </DialogTitle>
      <DialogContent>
        <div style={{ opacity: 0.8, color: "white" }}>
          This will reset all of your producers, are you sure you want to do
          this?
        </div>
        <FormControlLabel
          style={{ paddingTop: 24 }}
          control={
            <Checkbox
              checked={hideOnNextReset}
              onChange={(e) => {
                setHideOnNextReset(e.target.checked);
              }}
              style={{ color: "white", opacity: 0.8 }}
            />
          }
          label={
            <div style={{ color: "white", opacity: 0.8 }}>
              Hide this message on next reset
            </div>
          }
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>Cancel</Button>
        <Button
          onClick={() => {
            props.onReset();
            saveObjectToLocalStorage(
              "hideProducerStrengtheningDialog",
              hideOnNextReset
            );
            props.onClose();
          }}
        >
          Reset
        </Button>
      </DialogActions>
    </Dialog>
  );
}
